export const environment = {
    name: 'test' as 'test' | 'prod',
    production: false,
    keycloak: {
        url: 'https://idp.test.cnf.mucid.ch/auth/',
        realm: 'admin-portal',
        clientId: 'admin-portal-app'
    },
    apiBase: 'https://services.test.cnf.mucid.ch'
};
